import Icon from './Icon';

const Locked = ({ className }) => (
  <Icon name="locked" className={className} viewBox="0 0 410.769 410.769">
    <g>
      <path
        d="M49.201,176.495v234.274h312.367V176.495H49.201z M216.783,294.63h0.06v46.852H193.41V294.63h0.576
      c-8.508-4.211-14.37-12.954-14.37-23.087c0-14.229,11.537-25.766,25.771-25.766s25.771,11.537,25.771,25.766
      C231.153,281.677,225.291,290.419,216.783,294.63z"
      />
      <path
        d="M323.3,176.495h-40.61v-58.573c0-20.651-8.038-40.064-22.643-54.669
      c-14.596-14.601-34.014-22.643-54.665-22.643s-40.068,8.043-54.669,22.643c-14.605,14.609-22.643,34.022-22.643,54.669v58.573
      H87.46v-58.573c0-31.497,12.267-61.107,34.534-83.383C144.271,12.267,173.886,0,205.378,0c31.497,0,61.107,12.267,83.383,34.539
      c22.272,22.272,34.534,51.887,34.534,83.383v58.573H323.3z"
      />
    </g>
  </Icon>
);

export default Locked;
